import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, OnChanges, Output, ViewEncapsulation } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';

import { AnimationsEnum, BrandsEnum, IconSizeEnum, SdIconComponent, SdLibConfig, SdLinkComponent, SdTitleComponent } from '@seb/web-design-system/core';

import type { IDocument } from './document.interface';

@Component({
  selector: 'sd-document',
  templateUrl: './document.component.html',
  styleUrls: ['./document.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    SdLinkComponent,
    NgTemplateOutlet,
    SdIconComponent,
    SdTitleComponent
  ]
})
export class SdDocumentComponent implements OnChanges {
  @Input()
  brand?: BrandsEnum;

  @Input()
  titleLevel: number;

  @Input()
  data: IDocument;

  @Output()
  downloadedDocument = new EventEmitter<void>();

  @HostBinding('class')
  get hostClasses(): string {
    return [this.animation ? 'is-animation-' + this.animation : '']
      .filter(Boolean)
      .join(' ');
  }

  animation!: AnimationsEnum;
  iconSize = IconSizeEnum;

  constructor(private sdLibConfig: SdLibConfig) {}

  ngOnChanges() {
    this.animation = this.sdLibConfig.get(this.brand).animation;
  }

  onDownloadDocument() {
    this.downloadedDocument.emit();
  }
}
